import { trackHeapEvent } from './trackHeapEvent';

/**
 * Heap analytics JavaScript API.
 *
 * Taken from {@link https://developers.heap.io/reference/client-side-apis-overview#typescript-type-definitions}
 */
export interface Heap {
  track: (event: string, properties?: Record<string, unknown>) => void;
  identify: (identity: string) => void;
  resetIdentity: () => void;
  addUserProperties: (properties: Record<string, unknown>) => void;
  addEventProperties: (properties: Record<string, unknown>) => void;
  removeEventProperty: (property: string) => void;
  clearEventProperties: () => void;
  appid: string;
  userId: string;
  identity: string | null;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  config: any;
}

declare global {
  interface Window {
    heap?: Heap;

    // EverCommerce
    /**
     * Internal JavaScript API provided by EverCommerce, loaded through GTM
     */
    $EC?: {
      heap?: {
        /**
         * Create a unique but obfuscated ID associated with an email address,
         * to be used within Heap Analytics.
         */
        identify(emailAddress: string): string;
      };
    };
  }
}

export const heap = {
  /**
   * Create a unique but obfuscated ID associated with an email address,
   * to be used within Heap Analytics.
   *
   * If the API hasn't been loaded, this will fail silently and return an empty string.
   */
  identify(emailAddress: string): string {
    return window.$EC?.heap?.identify(emailAddress) ?? '';
  },

  /**
   * If Heap is loaded, track a Heap event. Otherwise, add it
   * to a queue of events to be tracked once Heap is loaded.
   */
  track: trackHeapEvent,
};
